// @flow

export const PIN_PAD_WIDTH = 252;
export const PIN_PAD_MINIMAL_HEIGHT = 524 + 32; //pinPad height + minimal padding from top and bottom combined
export const DEFAULT_PIN_PAD_MARGIN = 30;
export const COLLIDE_WIDTH = 490; // every display lower than this will make logo collide with pin pad
export const COLLIDE_HEIGHT = 620; // every display lower than this will make logo collide with pin pad
